import { useTranslation } from "react-i18next";
import { Building2 } from "lucide-react";

interface VenuesListEmptyProps {
  readonly hasFilters: boolean;
}

export function VenuesListEmpty({ hasFilters }: VenuesListEmptyProps) {
  const { t } = useTranslation();
  return (
    <div
      data-testid={hasFilters ? "venues-list-no-results" : "venues-list-empty"}
      className="rounded-lg border border-dashed border-border bg-card p-10 text-center"
    >
      <Building2 className="mx-auto mb-3 h-8 w-8 text-muted-foreground" aria-hidden="true" />
      <p className="font-sans text-base font-medium text-foreground">
        {hasFilters ? t("venuesDirectory.empty.filteredTitle") : t("venuesDirectory.empty.title")}
      </p>
      <p className="mt-1 font-sans text-sm font-normal text-muted-foreground">
        {hasFilters ? t("venuesDirectory.empty.filteredBody") : t("venuesDirectory.empty.body")}
      </p>
    </div>
  );
}
